export var FILLED_OPTION_SHADOW_ID = '';
export var OPTIONS_LIMIT = 100;